module.exports = __webpack_public_path__ + "img/third.e7a86925.svg";